import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Icon, Loader, Button } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
} from "./styles";
import swal from "sweetalert";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../../services/auth";

const ListarCursos = (props) => {
  const [cursos, setCursos] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const acao = JSON.stringify({ local: "cursos", texto: `listou os cursos` });
    api.post("system_logs", { acao });
  }, []);

  useEffect(() => {
    const params = {
      limit: 150,
      search,
    };

    api
      .get("/cursos-simplelist-new", { params })
      .then((res) => {
        setCursos(res.data.reverse());
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os cursos", err, "").then((res) =>
          props.history.push("/")
        );
      });
  }, [search]);

  return (
    <>
      <Container>
        <AdminMenu />

        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Cursos</Title>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Procurar curso..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Icon name="search icon" />

              <CreateButton to="/admin/ead/cursos/criar">Criar</CreateButton>
            </ContainerInputSearch>
            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Ação </SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>

              <SemanticTable.Body>
                {cursos.length > 0 ? (
                  cursos
                    // .filter((curso) =>
                    //   curso.curso.toLowerCase().includes(search.toLowerCase())
                    // )
                    .map((curso, index) => (
                      <SemanticTable.Row>
                        <SemanticTable.Cell>{curso.id}</SemanticTable.Cell>
                        <SemanticTable.Cell>{curso.curso}</SemanticTable.Cell>
                        <SemanticTable.Cell>
                          <>
                            <Button
                              icon="edit icon"
                              color={"blue"}
                              onClick={() =>
                                window.open(
                                  `/admin/ead/cursos/${curso.id}/modulos`
                                )
                              }
                            />
                          </>
                        </SemanticTable.Cell>
                      </SemanticTable.Row>
                    ))
                ) : (
                  <h1>Nenhum curso encontrado</h1>
                )}
              </SemanticTable.Body>
            </SemanticTable>
          </Content>
        )}
      </Container>
    </>
  );
};

export default ListarCursos;
